import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import axios from "axios";
import PropTypes from "prop-types";
import { handleApiError } from "@utils/errorHandler";
import PulseLoader from "react-spinners/PulseLoader";
import { WarningPopUp, Image, Anchor } from "hesus-ui-kit";
import ServiceHeader from "./ServiceHeader";
import QuoteItems from "./QuoteItems";
import planIcon from "@icons/ic-plan-order.svg";
import moreIcon from "@icons/ic-white-more.svg";
import Planning from "../Planning/Planning";
import {
  FollowUpSection,
  RowHeader,
  FlexRow,
  HeaderTitle,
  FollowUpPadding,
  GridRow,
  HeaderWrapperTable,
  Title,
  EnquiryIdHyphen,
  GridSubLabel,
  EnquiryHeader,
  QuoteInfoAndConditionsInfo,
  GridSubItem,
} from "./SiteFollowUp.styled";
import "../../SiteView.scss";

const SiteFollowUp = (props) => {
  const { t, siteId, siteNeedKickoff } = props;
  const [displayDropdown, setDisplayDropdown] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [quoteServiceId, setQuoteServiceId] = useState();
  const [quoteId, setQuoteId] = useState();
  const [data, setData] = useState([]);
  const [actionId, setActionId] = useState("");
  const [openPlanningPopUp, setOpenPlanningPopUp] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [serviceId, setServiceId] = useState([]);

  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState(
    "QUOTE_SERVICE_CONFIRMATION_BOX_DISABLE"
  );
  const [confirmationBoxContent, setConfirmationBoxContent] = useState(
    "QUOTE_SERVICE_CONFIRMATION_BOX_DISABLE_CONTENT"
  );

  const actionDropdownToggle = (id) => {
    setActionId(id);
    setDisplayDropdown(!displayDropdown);
  };

  const planningAction = (id) => {
    setServiceId(id);
    setOpenPlanningPopUp(true);
  };

  const closePlanningPopUp = () => {
    setServiceId();
    setOpenPlanningPopUp(false);
  };

  const openPopUpQuoteAction = (id, quoteId) => {
    setQuoteServiceId(id);
    setQuoteId(quoteId);
    setDisplayDropdown(false);
    setConfirmVisibility(true);
    setActionId("");
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
    setQuoteServiceId();
    setQuoteId();
    setActionId();
  };

  const fetchQuoteFollowUp = () => {
    setIsLoading(true);
    axios
      .get(`/sites/${siteId}/followup`)
      .then((response) => {
        setData(response.data?.followup);
        setIsRefresh(false);
        setIsLoading(false);
      })
      .catch((error) => handleApiError(error));
  };

  useEffect(() => {
    fetchQuoteFollowUp();
  }, [siteId]);

  useEffect(() => {
    if (isRefresh) fetchQuoteFollowUp();
  }, [isRefresh]);

  useEffect(() => {
    if (isConfirm) {
      const formStatus = "0";
      axios
        .post(
          `/quotes/${quoteId}/services/${quoteServiceId}/updateStatus`,
          formStatus
        )
        .then((response) => {
          setData(response.data[0]);
          setIsRefresh(true);
        })
        .catch((error) => handleApiError(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  return (
    <>
      <FollowUpSection>
        {isLoading && (
          <div className="suggestions-list-loading">
            <PulseLoader color="#1bace4" size={15} />
          </div>
        )}
        {!isLoading && (
          <>
            <FlexRow column="1fr">
              <HeaderTitle>{t("SITE_FOLLOWUP_TITLE")}</HeaderTitle>
            </FlexRow>
            <FollowUpPadding>
              <RowHeader>
                <GridRow
                  column="40% 15% 15% 15% 15%"
                  marginTop="0px"
                  marginBottom="0px"
                  gridGap="0rem"
                >
                  <ServiceHeader
                    title="FOLLOWUP_TABLE_SERVICES"
                    borderRadius="left"
                    align="left"
                  />
                  <ServiceHeader
                    title="FOLLOWUP_TABLE_ORDERED"
                    align="center"
                  />
                  <ServiceHeader
                    title="FOLLOWUP_TABLE_PLANNED"
                    align="center"
                  />
                  <ServiceHeader
                    title="FOLLOWUP_TABLE_REALISED"
                    align="center"
                  />
                  <ServiceHeader
                    title="FOLLOWUP_TABLE_TURNOVER"
                    borderRadius="right"
                    align="right"
                  />
                </GridRow>
              </RowHeader>
              <EnquiryHeader>
                {data?.length > 0 &&
                  data.map((service, serviceIndex) => {
                    const needPlaning =
                      Object.keys(service.services).length === 1 &&
                      !service.services[0].hesusService.needClientOrder
                        ? false
                        : true;

                    return (
                      <React.Fragment key={"siteFollowup" + serviceIndex}>
                        <GridRow marginBottom="0px" marginTop="0px">
                          <HeaderWrapperTable
                            color={service?.isActive ? "#3ebbb9" : "#767676"}
                          >
                            <GridRow
                              column="auto 80% 1fr"
                              marginBottom="0px"
                              marginTop="0px"
                              gridGap=".5rem"
                            >
                              <Title
                                marginTop="6px"
                                fontWeight="bold"
                                fontSize="16px;"
                              >
                                <Anchor
                                  url={`/site/view/${siteId}/enquiry-view-${service.enquiryId}`}
                                  target="_blank"
                                  className="site-view-enquiry__followup-link"
                                >
                                  {t("ENQUIRY") + " #" + service?.enquiryId}
                                </Anchor>
                                <EnquiryIdHyphen decoration="none">
                                  {" "}
                                  -{" "}
                                </EnquiryIdHyphen>
                              </Title>
                              <GridSubLabel fontSize="16px">
                                {service?.label}
                              </GridSubLabel>
                              <GridSubItem textAlign="right">
                                {!!service.canSchedule &&
                                  !!service?.isActive &&
                                  needPlaning && (
                                    <Image
                                      src={planIcon}
                                      title={t("QUOTE_SERVICE_PLANNING")}
                                      alt={t("QUOTE_SERVICE_PLANNING")}
                                      onClick={() =>
                                        planningAction(service?.id)
                                      }
                                      className="site-view-enquiry__quote-icon"
                                    />
                                  )}
                                {!!service.isActive && (
                                  <Image
                                    src={moreIcon}
                                    onClick={() =>
                                      actionDropdownToggle(service.id)
                                    }
                                    title={t("QUOTE_SERVICE_ACTION")}
                                    alt={t("QUOTE_SERVICE_ACTION")}
                                    className="site-view-enquiry__quote-icon"
                                  />
                                )}
                                {displayDropdown &&
                                  parseInt(service.id) === actionId && (
                                    <div className="quote-listing__dropdown-container">
                                      <ul className="quote-listing__dropdown-list">
                                        <li
                                          className="quote-listing__list-item"
                                          onClick={() =>
                                            openPopUpQuoteAction(
                                              service.id,
                                              service.quoteId
                                            )
                                          }
                                        >
                                          <label className="document-label">
                                            {t("QUOTE_SERVICE_DISABLE")}
                                          </label>
                                        </li>
                                      </ul>
                                    </div>
                                  )}
                              </GridSubItem>
                            </GridRow>
                          </HeaderWrapperTable>
                        </GridRow>
                        <QuoteInfoAndConditionsInfo
                          marginBottom="0px"
                          padding="0px"
                          boxShadow="0px 0px 0px 0px rgba(0,76,127,0.25)"
                        >
                          <QuoteItems
                            itemList={service.services}
                            serviceStatus={service?.isActive}
                            currency={service?.quoteCurrency}
                            serviceCurrency={service?.servicesCurrency}
                            exchangeRates={service?.exchangeRates}
                            siteNeedKickoff={siteNeedKickoff}
                          />
                        </QuoteInfoAndConditionsInfo>
                      </React.Fragment>
                    );
                  })}
              </EnquiryHeader>
            </FollowUpPadding>
          </>
        )}
      </FollowUpSection>
      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent="VALIDATE"
          CancelContent="CANCEL"
        />
      )}
      {openPlanningPopUp && (
        <Planning
          onClose={closePlanningPopUp}
          siteId={siteId}
          serviceId={serviceId}
          onRefreshData={setIsRefresh}
        />
      )}
    </>
  );
};

SiteFollowUp.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SiteFollowUp);
